import React, { useEffect, useState } from "react";
import { Box, Link as MuiLink } from "@material-ui/core";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Alert } from "@mui/material";
import { LicenseInfo } from "@mui/x-data-grid-premium";
import { Header } from "./Header";
import { SideNav } from "./SideNav";

LicenseInfo.setLicenseKey(
  "f58808a273a06ffee8ecfb7656547e32Tz01NDYwMCxFPTE3MDAzNTQ5NzI0NzMsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y"
);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      height: "100vh",
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      maxHeight: "100vh",
      padding: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      overflow: "auto",
      [theme.breakpoints.down(1260)]: {
        overflowY: "scroll",
        minWidth: "1100px",
        overflowX: "none",
      },
      [theme.breakpoints.down(960)]: {
        overflowY: "none",
        overflowX: "auto",
        minWidth: "initial",
      },
    },
    marginBottom: {
      marginTop: "-15px",
      fontSize: "13px !important",
    },
    Muilink: {
      textDecoration: "underline",
      color: "blue",
    },
    // hidden: {
    //   overflow: "hidden",
    //   background: "red",
    // },
  })
);

interface Props {
  children: React.ReactNode;
}

export function Layout(props: Props) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => setOpen((prev) => !prev);
  useEffect(() => {
    if (document.body.classList.contains("hidden")) {
      document.body.classList.remove("hidden");
    }
  });
  return (
    <div className={classes.root}>
      <Header open={open} toggleDrawer={toggleDrawer} />
      <SideNav open={open} toggleDrawer={toggleDrawer} />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Alert className={classes.marginBottom} severity="info">
          TFG National has recently implemented new processes that are impacting our Accounting
          teams turnaround time. If you have an emergency issue or concern, we have created a new
          mailbox that is being closely monitored by our team. Please reach out to{" "}
          <MuiLink className={classes.Muilink} href="mailto:ispconcerns@thefacilitiesgroup.com">
            ispconcerns@thefacilitiesgroup.com
          </MuiLink>{" "}
          with an overview of your concerns and we will work to expedite your request. We are
          committed to ensuring all payments are made for services rendered.
        </Alert>
        <Box mt={1}>{props.children}</Box>
      </main>
    </div>
  );
}
